import * as d3 from 'd3'

export default {
  methods: {

    draw_Handover() {

      this.canvasOptions = this.canvasForm
      .append('g')
      .attr('transform', `translate(0, 0)`)

      let y_ = 490
      this.handover.forEach(d=> {
        let handover = this.canvasOptions
        .append('g')
        .attr('id', `UNIT_${d.code}`)
        .attr('transform', `translate(45, ${y_})`)
        .attr('opacity', this.current.handover == d.code ? 1 : 0.8)
        .attr('cursor', 'pointer')
        .on('mouseover', () => { 
          d3.select(`#UNIT_${d.code}`).attr('opacity', this.current.handover == d.code ? 1 : 0.6) 
        })
        .on('mouseout', () => { 
          d3.select(`#UNIT_${d.code}`).attr('opacity', this.current.handover == d.code ? 1 : 0.8)
        })
        .on('click', ()=> {
          if(this.current.handover == d.code) return
          d3.select(`#UNIT_${this.current.handover}`).transition().duration(300).attr('opacity', .8) 
          d3.select(`#UNIT_TXT_${this.current.handover}`).transition().duration(300).attr('font-weight', 400).attr('fill', '#333')
          d3.select(`#UNIT_IN_${this.current.handover}`).transition().duration(300).attr('opacity', 0)
          d3.select(`#UNIT_OUT_${this.current.handover}`).transition().duration(300).attr('stroke', '#bcbcbc')

          this.current.handover = d.code
          d3.select(`#UNIT_${d.code}`).transition().duration(150).attr('opacity', 1) 
          d3.select(`#UNIT_TXT_${d.code}`).transition().duration(150).attr('font-weight', 450).attr('fill', '#000')
          d3.select(`#UNIT_IN_${d.code}`).transition().duration(150).attr('opacity', 1)
          d3.select(`#UNIT_OUT_${d.code}`).transition().duration(150).attr('stroke', '#44A9DF')
          
          this.current.page = 1
          this.filteringData()
          
          this.canvasSystems.remove()
          this.draw_SystemList()
        })
        
        handover
        .append('circle')
        .attr('id', `UNIT_OUT_${d.code}`)
        .attr('transform', `translate(0, -0.5)`)
        .attr('r', 6).attr('stroke', this.current.handover == d.code ? '#44A9DF' : '#bcbcbc').attr('stroke-width', 1).attr('fill', '#fff')

        handover
        .append('circle')
        .attr('id', `UNIT_IN_${d.code}`)
        .attr('transform', `translate(0,-0.5)`)
        .attr('r', 3).attr('stroke', '#44A9DF')
        .attr('stroke-width', 0).attr('fill', '#44A9DF').attr('opacity', this.current.handover == d.code ? 1 : 0)

        handover
        .append('text')
        .attr('id', `UNIT_TXT_${d.code}`)
        .attr('transform', `translate(11, 3.5)`)
        .attr('font-size', 10).attr('fill', '#000').attr('text-anchor', 'start')
        .attr('font-weight', this.current.handover == d.code ? 450 : 400)
        .text(`${d.name} (${d.count})`)

        y_ += 20
      })

      this.draw_Summary()
    },


    draw_Summary() {
      this.loadSvg(
        this.canvasOptions, {x: this.innerSVG.summary.x, y: this.innerSVG.summary.y, url: this.Boundary + `Form_Index.svg`}
      ).then(() => {
        d3.selectAll('text').style('font-family', 'roboto')

        this.summary.filter(f=> f.type =='PRO').forEach(d=> {
          let matrix = this.gmx_matrix2(`#${d.id}`)
          d3.select(`#${d.id}`).attr('transform', null).attr('x', matrix.x).attr('y', matrix.y)
        })
      })
    },


    draw_SummaryReflash(data) {
      
      // TEXT
      this.summary.filter(f=> !f.type).forEach(d=> {
        if(d.id == 'SUM-SYS' || d.id == 'SUM-DESC') d3.select(`#${d.id}`).text(data[d.code].length > 45 ? data[d.code].substr(0,45) + '...' : data[d.code])
        else {
          d3.select(`#${d.id}`).attr('text-anchor', 'end')
          .style('fill', data[d.code] == 0 ? '#bcbcbc' : '#333')
          .call(this.event_Link, data, d.code, d.req, d.filter)
          this.gmx_textTween(`#${d.id}`, data[d.code], 300)
        }
      })

      // Progress BAR
      this.summary.filter(f=> f.type).forEach(d=> {

        if(d.type=='PRO') {
          let x = this.innerSVG.summary.pro + Number(data[d.code])
          d3.select(`#${d.id}`).transition().duration(500)
          .attr('x', data[d.code] < 70 ? x+2 : x-2)
          .attr('text-anchor', data[d.code] < 70 ? 'start' : 'end')
          .text(data[d.code]+'%')
        }

        if(d.type=='BAR') {
          d3.select(`#${d.id}`).transition().duration(500)
          .attr('width', data[d.code])
        }

      })
    },


    init_Summary() {
      // TEXT
      this.summary.filter(f=> !f.type).forEach(d=> {
        if(d.id == 'SUM-SYS' || d.id == 'SUM-DESC') d3.select(`#${d.id}`).text('')
        else d3.select(`#${d.id}`).text(0)
      })

      // Progress BAR
      this.summary.filter(f=> f.type).forEach(d=> {
        if(d.type=='PRO') d3.select(`#${d.id}`).text('0%')
        if(d.type=='BAR') d3.select(`#${d.id}`).attr('width', 0)
      })
    },

  }
}